import formData from 'form-data';
import Mailgun from 'mailgun.js';

export const sendEmail = {
  createEmail: (msgBody, msgSubject, emailAddress, htmlView) => {
    const apiKey = process.env.NEXT_PUBLIC_MAILGUN_API_KEY;
    const DOMAIN = process.env.NEXT_PUBLIC_MAILGUN_DOMAIN;

    console.log('api - key', apiKey, DOMAIN);
    const mailgun = new Mailgun(formData);
    const mg = mailgun.client({
      username: 'api',
      key: apiKey
    });

    const data = {
      from: 'lanetBoutique <info@lanetboutique.co.zw>',
      to: emailAddress,
      subject: msgSubject,
      text: msgBody,
      html: htmlView
    };
    mg.messages
      .create(DOMAIN, data)
      .then((response) => {
        console.log(response);
      })
      .catch((err) => {
        console.error(err);
      });
  }
};
